<template>
  <div class="operator-button_block">
    <div class="left">
      <ButtonWithDescriptionBox
        :link="{name: 'UpdatingOperator', params: null}"
        description="作図にかかる時間と必要なスキルなどを入力し、マッチングを待ちます。"
        button-name="新規受注・登録時間変更"
        button-color="orange"/>
      <ButtonWithDescriptionBox
        v-if="customClaim.isOwner"
        :link="{name: 'PaymentTop', params: null}"
        description="入金に必要な情報を登録したり、入金依頼を行うことが出来ます。"
        button-name="入金"
        button-color="orange"/>
    </div>
    <div class="right">
      <ButtonWithDescriptionBox
        v-if="isExistMatching"
        :link="newestMatchingLink"
        description="受注済みの案件のステータスがわかります。マッチングを待っている場合もこちらです。"
        button-name="受注中案件管理"
        button-color="yellow"/>
      <ButtonWithDescriptionBox
        :link="{name: 'RetrievingMatchings', params: null}"
        description="完了案件の一覧を確認できます。"
        button-name="完了案件一覧"
        button-color="blue"/>
    </div>
  </div>
</template>

<script>
  import ButtonWithDescriptionBox from "@/components/molecules/box/button/ButtonWithDescriptionBox";
  import {mapGetters} from "vuex";
  import STATUSES from "@/assets/js/constants/statuses";

  export default {
    name: "OperatorButtonBlock",

    components: {ButtonWithDescriptionBox},

    props: {
      matching: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters({customClaim: 'auth/customClaim'}),

      isExistMatching() {
        return !!this.matching && !!this.matching.status;
      },
      isAcceptedMatching() {
        return (this.matching.clientStatus ===  STATUSES.ACCEPT.name && this.matching.operatorStatus ===  STATUSES.ACCEPT.name)
      },
      isNewestMatchingWaiting() {
        return (this.isExistMatching && !this.isAcceptedMatching);
      },
      isNewestMatchingActive() {
        return (this.isExistMatching && this.isAcceptedMatching);
      },
      newestMatchingLink() {
        if (this.isNewestMatchingWaiting) {
          return {name: 'MatchingDetail', params: {matchingId: this.matching.id}};
        } else if (this.isNewestMatchingActive) {
          return {name: 'Meeting', params: {matchingId: this.matching.id}};
        }
        return null;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .operator-button_block {
    @include double_columns($left: 40%, $right: 40%);

    .button-with-description-box {
      margin-top: 2rem;
    }
  }
</style>
